import React from 'react'
import ResultItem from '../../../pack/form/result/ResultItem'

const WorkLinePlaceResultWarehouse = ({ result }) => {
  return (
    <>
        {
            result && result.department && result.department.type && result.department.type === 'warehouse' ?
                <>
                    {/* <ResultItem
                        text='Назва (повна)'
                        value={result && result.department ? result.department.name : ''}
                    /> */}
                    <ResultItem
                        text='Назва (коротка)'
                        value={result && result.department ? result.department.slug : ''}
                    />
                </>
            : ''
        }
    </>
  )
}

export default WorkLinePlaceResultWarehouse